import PageHero from "@/components/PageHero";
import { Target, Eye, ShieldCheck, Award, GraduationCap, Globe2, Scale, Network } from "lucide-react";
import { BRAND } from "@/lib/brand";

export default function About() {
  return (
    <div data-testid="about-page">
      <PageHero
        eyebrow="About the Federation"
        title="The National Governing Body for Karate in India"
        subtitle="NKF Bharat unites Traditional, Semi-Contact and Full-Contact Karate under one transparent national federation — recognised by international bodies and trusted by athletes nationwide."
      />
      <section className="section-spacing nkf-container">
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-6 items-stretch">
          {[
            { icon: Target, title: "Mission", body: "Let's unite on one platform to promote karate sports in India." },
            { icon: Eye, title: "Vision", body: "A world-class, transparent and inclusive national federation enabling Indian karatekas to compete globally." },
            { icon: ShieldCheck, title: "Governance", body: "Federated structure with 28 State Units & 312 District Units under a single national rulebook." },
            { icon: Award, title: "Recognition", body: "Officially recognised by international and national karate governing bodies — see the Recognitions page." },
            { icon: GraduationCap, title: "Education", body: "Continuous coach, referee and master courses — including refresher programmes and technical seminars." },
            { icon: Globe2, title: "International", body: "Active partnerships with ITKF, IAKS, ICSSPE, TAFISA and UKF for global representation." },
            { icon: Scale, title: "Transparency", body: "Public athlete & coach registries with clear grievance and disciplinary procedures." },
            { icon: Network, title: "Expansion", body: "Continuous growth across rural & urban India with structured pathways for grass-roots talent." },
          ].map(({ icon: Icon, title, body }) => (
            <div key={title} className="federation-card border border-slate-200 rounded-md p-6 bg-white flex flex-col h-full">
              <Icon className="h-7 w-7 text-nkf-red" />
              <h3 className="font-display text-xl text-nkf-blue mt-4">{title}</h3>
              <p className="text-sm text-slate-600 mt-2 leading-relaxed flex-1">{body}</p>
            </div>
          ))}
        </div>

        <div className="mt-12 p-8 rounded-md bg-nkf-navy text-white">
          <div className="text-[11px] uppercase tracking-[0.3em] text-nkf-gold">Federation Statement</div>
          <div className="font-display text-3xl md:text-4xl mt-2">{BRAND.statement}</div>
          <div className="hindi text-nkf-gold mt-3 text-lg">{BRAND.slogan.join(" | ")}</div>
        </div>
      </section>
    </div>
  );
}
